import React, { useState } from 'react'
import { Col, Row, SelectPicker, IconButton, Icon, DatePicker } from 'rsuite'
import { DATE_FORMAT, DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../constants/date'
import moment from 'moment'
import PreviewButton from '../../components/buttons/previewButton/PreviewButton'

export default function DailyPayBookSeach({
  schema,
  loading,
  projectStartDate,
  projectEndDate,
  onSearch = () => {},
  onExport = () => {},
  ...props
}) {
  const [period, setPeriod] = useState()
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()

  return (
    <>
      {schema.periodOption && (
        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <b>{schema.periodOption.label} : </b>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <SelectPicker
              searchable={false}
              data={schema.periodOption.options}
              value={period}
              block
              placeholder={schema?.periodOption?.placeholder || ''}
              onChange={(value) => {
                setPeriod(value)
              }}
            />
          </Col>
        </Row>
      )}

      {schema?.startDate && schema?.endDate && (
        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'end' }}>
            <b>{schema.startDate.label || 'วันที่เริ่มต้น'} : </b>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <DatePicker
              oneTap
              block
              format={DATE_PICKER_FORMAT}
              locale={LOCAL_DAY_TH}
              value={startDate}
              onChange={(value) => {
                setStartDate(value)
              }}
              onClean={() => {
                setStartDate(null)
              }}
              disabledDate={(date) =>
                (projectStartDate &&
                  moment(projectStartDate).startOf('day').isAfter(date, new Date())) ||
                (projectEndDate &&
                  moment(projectEndDate)
                    .startOf('day')
                    .add(1, 'days')
                    .isBefore(date, new Date())) ||
                (endDate && moment(endDate).isBefore(date, new Date()))
              }
            />
          </Col>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'end' }}>
            <b>{schema.endDate.label || 'วันที่สิ้นสุด'} : </b>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <DatePicker
              oneTap
              block
              format={DATE_PICKER_FORMAT}
              locale={LOCAL_DAY_TH}
              value={endDate}
              onChange={(value) => {
                setEndDate(value)
              }}
              onClean={() => {
                setStartDate(null)
              }}
              disabledDate={(date) =>
                (projectStartDate &&
                  moment(projectStartDate).startOf('day').isAfter(date, new Date())) ||
                (projectEndDate &&
                  moment(projectEndDate)
                    .startOf('day')
                    .add(1, 'days')
                    .isBefore(date, new Date())) ||
                (startDate && moment(startDate).isAfter(date, new Date()))
              }
            />
          </Col>
        </Row>
      )}

      <Row style={{ marginTop: 10 }}>
        <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'end' }}></Col>
        <Col lg={20} md={20} sm={24} xs={24}>
          <PreviewButton
            disabled={loading}
            onClick={() => {
              onSearch({
                period: period || 0,
                startDate: startDate ? moment(startDate).format(DATE_FORMAT) : '',
                endDate: endDate ? moment(endDate).format(DATE_FORMAT) : '',
              })
            }}
          />
          <IconButton
            appearance="ghost"
            icon={<Icon icon="file-excel-o" className="bt-gost-icon-radius" />}
            disabled={loading}
            onClick={() => {
              onExport({
                period: period || 0,
                startDate: startDate ? moment(startDate).format(DATE_FORMAT) : '',
                endDate: endDate ? moment(endDate).format(DATE_FORMAT) : '',
              })
            }}
            style={{ marginBottom: 10 }}
          >
            Export to MS-Excel
          </IconButton>
        </Col>
      </Row>
    </>
  )
}
